// @mui
import { Container, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { imageProps } from '@utils/image';
import NextImage from "next/image";
import { ArticleProps } from 'src/@types/article';
// components
import { BgOverlay } from '../../components';
// utils
import { fDate } from '../../utils/formatTime';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(20, 0),
}));

// ----------------------------------------------------------------------

type Props = {
  article: ArticleProps;
};

export default function BlogPostHero({ article }: Props) {
  const { title, date, header } = article;

  return (
    <RootStyle>
      <Container sx={{ position: 'relative', zIndex: 9 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Stack
              spacing={3}
              alignItems={{
                xs: 'center',
                md: 'flex-start',
              }}
              sx={{
                color: 'common.white',
                textAlign: {
                  xs: 'center',
                  md: 'left',
                },
              }}
            >
              <Typography variant="body2" sx={{ opacity: 0.72 }}>
                Aktuelt
              </Typography>

              <Typography variant="h2" component="h1">
                {title}
              </Typography>

              <Typography variant="caption" sx={{ opacity: 0.72 }}>
                {fDate(date, 'dd/MM/yyyy p')}
              </Typography>

              {/* <SocialsButton initialColor links={shareLinks} /> */}
            </Stack>
          </Grid>
        </Grid>
      </Container>

      <BgOverlay sx={{ opacity: 0.8 }} />

      <Box sx={{ overflow: 'hidden', position: 'absolute', top: 0, left: 0, width: 1, height: 1 }}>
        <NextImage alt="hero" layout="fill" objectFit='cover' {...imageProps(header, true)} />
      </Box>
    </RootStyle>
  );
}
